import React, { useEffect } from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import { PageProps } from "./models/global";
import Home from "./pages/Home";
import { useLanguage } from "./LanguageContext";
import { VALID_LANGUAGE_CODES } from "./config/languages";
import Product from "./pages/Product";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import ProductDetail from "./pages/ProductDetail";

const LanguageGuard = ({ children }: { children: React.ReactNode }) => {
  const { lang } = useParams<{ lang: string }>();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (lang && VALID_LANGUAGE_CODES.includes(lang as any)) {
      setLanguage(lang as 'en' | 'fr');
    }
  }, [lang, setLanguage]);

  if (!lang || !VALID_LANGUAGE_CODES.includes(lang as any)) {
    return <Navigate to="/en" replace />;
  }

  return <>{children}</>;
};

const Navigation = (props: PageProps) => {
  return (
    <Routes>
      {/* Root redirect to default language (fr) */}
      <Route path="/" element={<Navigate to="/fr" replace />} />

      {/* Language-prefixed routes */}
      <Route
        path="/:lang"
        element={
          <LanguageGuard>
            <Home start={props.start} />
          </LanguageGuard>
        }
      />

      <Route
        path="/:lang/products"
        element={
          <LanguageGuard>
            <Product start={props.start} />
          </LanguageGuard>
        }
      />

      <Route
        path="/:lang/products/:slug"
        element={
          <LanguageGuard>
            <ProductDetail />
          </LanguageGuard>
        }
      />

      <Route
        path="/:lang/blog"
        element={
          <LanguageGuard>
            <Blog start={props.start} />
          </LanguageGuard>
        }
      />

      <Route
        path="/:lang/blog/:slug"
        element={
          <LanguageGuard>
            <BlogDetail />
          </LanguageGuard>
        }
      />

      {/* Catch-all redirect for invalid languages */}
      <Route path="*" element={<Navigate to="/fr" replace />} />
    </Routes>
  );
};

export default Navigation;
